import AuthenticationPage from 'pages/AuthenticationPage';
import HealthPlansPage from 'pages/HealthPlansPage';
import HealthPlansCategoriesPage from 'pages/HealthPlansCategoriesPage';
import DoctorConsultationsPriceListsPage from 'pages/DoctorConsultationsPriceListsPage';
import DoctorConsultationsProvidersPage from 'pages/DoctorConsultationsProvidersPage';
import PharmaciesPriceListsPage from 'pages/PharmaciesPriceListsPage';
import PharmaciesProvidersPage from 'pages/PharmaciesProvidersPage';
import LabsPriceListssPage from 'pages/LabsPriceListsPage';
import LabsProvidersPage from 'pages/LabsProvidersPage';
import ScansPriceListsPage from 'pages/ScansPriceListsPage';
import ScansProvidersPage from 'pages/ScansProvidersPage';
import ClinicServicePriceListsPage from 'pages/ClinicServicePriceListsPage';
import ClinicServiceProvidersPage from 'pages/ClinicServiceProvidersPage';
import SurgicalPriceListsPage from 'pages/SurgicalPriceListsPage';
import SurgicalProvidersPage from 'pages/SurgicalProvidersPage';
import ProviderDiscountsPage from 'pages/ProviderDiscountsPage';

const routes = {
  public: [
    {
      path: '/callback',
      component: <AuthenticationPage />,
    },
  ],
  private: [
    {
      path: '/health-plans',
      component: <HealthPlansPage />,
    },
    {
      path: '/health-plans/:healthPlanId',
      component: <HealthPlansCategoriesPage />,
    },
    // Doctor Consultation Category
    {
      path: '/health-plans/:healthPlanId/doctor-consultations-price-lists',
      component: <DoctorConsultationsPriceListsPage />,
    },
    {
      path: '/health-plans/:healthPlanId/doctor-consultations-price-lists/:priceListId',
      component: <DoctorConsultationsProvidersPage />,
    },
    // Pharmacies Category
    {
      path: '/health-plans/:healthPlanId/pharmacies-price-lists',
      component: <PharmaciesPriceListsPage />,
    },
    {
      path: '/health-plans/:healthPlanId/pharmacies-price-lists/:priceListId',
      component: <PharmaciesProvidersPage />,
    },
    // Labs Category
    {
      path: '/health-plans/:healthPlanId/labs-price-lists',
      component: <LabsPriceListssPage />,
    },
    {
      path: '/health-plans/:healthPlanId/labs-price-lists/:priceListId',
      component: <LabsProvidersPage />,
    },
    // Scans Category
    {
      path: '/health-plans/:healthPlanId/scans-price-lists',
      component: <ScansPriceListsPage />,
    },
    {
      path: '/health-plans/:healthPlanId/scans-price-lists/:priceListId',
      component: <ScansProvidersPage />,
    },
    // Clinic Services
    {
      path: '/health-plans/:healthPlanId/clinical-services-price-lists',
      component: <ClinicServicePriceListsPage />,
    },
    {
      path: '/health-plans/:healthPlanId/clinical-services-price-lists/:priceListId',
      component: <ClinicServiceProvidersPage />,
    },
    // Surgical
    {
      path: '/health-plans/:healthPlanId/surgical-price-lists',
      component: <SurgicalPriceListsPage />,
    },
    {
      path: '/health-plans/:healthPlanId/surgical-price-lists/:priceListId',
      component: <SurgicalProvidersPage />,
    },
    // Provider Discounts
    {
      path: '/health-plans/:healthPlanId/provider-discounts',
      component: <ProviderDiscountsPage />,
    },
  ],
};

export default routes;
